export type DeploymentStage = "DEV" | "TST" | "HML" | "PRD";

const STAGE_BY_HOSTNAME: Record<string, DeploymentStage> = {
  "portal-tst.saudedigital.online": "TST",
  "portal-hml.saudedigital.online": "HML",
  "portaltst.saudedigital.online": "TST",
  "portalhml.saudedigital.online": "HML",
  "portal-prd.saudedigital.online": "PRD",
  "portal.saudedigital.online": "PRD",
};

export function detectDeploymentStage(hostname: string, _envStageOverride?: string): DeploymentStage {
  const normalizedHostname = hostname.trim().toLowerCase();
  return STAGE_BY_HOSTNAME[normalizedHostname] ?? "DEV";
}

export function getEnvironmentIndicator(hostname: string, envStageOverride?: string) {
  const normalizedHostname = hostname.trim() || "localhost";
  const stage = detectDeploymentStage(normalizedHostname, envStageOverride);

  return {
    stage,
    label: `Ambiente ${stage}`,
    host: normalizedHostname,
    tone: {
      DEV: "border-sky-200 bg-sky-50 text-sky-900",
      TST: "border-violet-200 bg-violet-50 text-violet-900",
      HML: "border-amber-200 bg-amber-50 text-amber-900",
      PRD: "border-emerald-200 bg-emerald-50 text-emerald-900",
    }[stage],
  };
}
